// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header__secondary .nuxt-link-exact-active,.header__transparent .nuxt-link-exact-active{background-color:#2e3241;border-bottom:none}.header__discovery .nuxt-link-exact-active{color:#000517!important;background-color:#ddca6d;border-radius:8px;border-bottom:none}.header__transparent{background-color:transparent!important;background:linear-gradient(180deg,#000517 16.43%,rgba(0,5,23,0))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
